var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-edit" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "Widget",
        { attrs: { title: (_vm.isNew ? "New" : "Edit") + " country" } },
        [
          !_vm.isNew && _vm.isReceiving
            ? _c("Loader", { attrs: { size: 40 } })
            : _c(
                "Form",
                [
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "name" } },
                      [_vm._v("Country name")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "name", type: "text" },
                        domProps: { value: _vm.country.name },
                        on: {
                          change: function($event) {
                            return _vm.updateCountryProperty($event, "name")
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "code" } },
                      [_vm._v("Country code")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "code", type: "text" },
                        domProps: { value: _vm.country.code },
                        on: {
                          change: function($event) {
                            return _vm.updateCountryProperty($event, "code")
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "code" } },
                      [_vm._v("AD code")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "ADCode", type: "text" },
                        domProps: { value: _vm.country.adCode },
                        on: {
                          change: function($event) {
                            return _vm.updateCountryProperty($event, "adCode")
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "timezone" } },
                      [_vm._v("Timezone")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("v-select", {
                          attrs: {
                            id: "timezone",
                            options: _vm.getTimezoneOptions()
                          },
                          model: {
                            value: _vm.country.timezone,
                            callback: function($$v) {
                              _vm.$set(_vm.country, "timezone", $$v)
                            },
                            expression: "country.timezone"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.errorsList, function(error) {
                    return _c(
                      "b-alert",
                      {
                        key: error,
                        staticClass: "alert-sm w-25",
                        attrs: {
                          variant: "danger",
                          show: _vm.errorsList.length > 0
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(error) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button-toolbar",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: {
                            click: function($event) {
                              return _vm.saveCountry()
                            }
                          }
                        },
                        [
                          _vm.isUpdating
                            ? _c("Loader")
                            : _c("span", [_vm._v("Save")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "default" },
                          on: {
                            click: function($event) {
                              return _vm.goBack()
                            }
                          }
                        },
                        [_vm._v("\n                    Back\n                ")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "page-title" }, [
      _vm._v(
        "Country                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    - "
      ),
      _c("span", { staticClass: "fw-semi-bold" }, [_vm._v("Detail")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }